// components/shared/notifications/NotificationPreview.tsx
import React from "react";
import { Bell } from "lucide-react";

interface NotificationPreviewProps {
  title: string;
  message: string;
  type?: string;
  priority?: string;
  actionLabel?: string;
  image?: string;
}

export const NotificationPreview: React.FC<NotificationPreviewProps> = ({
  title,
  message,
  type,
  priority,
  actionLabel,
  image,
}) => {
  const getTypeColor = (type?: string) => {
    const colors: Record<string, string> = {
      TRANSACTION: "bg-green-100 text-green-800",
      SYSTEM: "bg-green-100 text-green-800",
      ADMIN: "bg-purple-100 text-purple-800",
      KYC: "bg-yellow-100 text-yellow-800",
      PROMOTION: "bg-pink-100 text-pink-800",
      SECURITY: "bg-red-100 text-red-800",
    };
    return colors[type || ""] || "bg-gray-100 text-gray-800";
  };

  const getPriorityColor = (priority?: string) => {
    const colors: Record<string, string> = {
      LOW: "bg-green-100 text-green-800 border-green-300",
      NORMAL: "bg-green-100 text-green-800 border-green-300",
      HIGH: "bg-orange-100 text-orange-800 border-orange-300",
      URGENT: "bg-red-100 text-red-800 border-red-300",
    };
    return colors[priority || ""] || "bg-gray-100 text-gray-800 border-gray-300";
  };

  return (
    <div className="p-4 bg-white rounded-lg shadow-sm">
      {image && <img src={image} alt="Preview" className="object-cover mb-3 w-full h-32 rounded-lg" />}
      <div className="flex gap-3 items-start">
        <div className="flex justify-center items-center w-10 h-10 bg-green-100 rounded-full">
          <Bell className="w-5 h-5 text-green-600" />
        </div>
        <div className="flex-1">
          {(type || priority) && (
            <div className="flex gap-2 items-center mb-1">
              {type && <span className={`text-xs px-2 py-1 rounded ${getTypeColor(type)}`}>{type}</span>}
              {priority && (
                <span className={`text-xs px-2 py-1 rounded border ${getPriorityColor(priority)}`}>{priority}</span>
              )}
            </div>
          )}
          <p className="font-semibold text-gray-900">{title || "Titre de la notification"}</p>
          <p className="mt-1 text-sm text-gray-600">{message || "Message de la notification"}</p>
          {actionLabel && <button className="mt-2 text-sm font-medium text-green-600">{actionLabel}</button>}
        </div>
      </div>
    </div>
  );
};
